// extracted by mini-css-extract-plugin
export default {"root":"_3BoR_","left":"_3A9_k","left-side-item-wrapper":"GUM_8","leftSideItemWrapper":"GUM_8","right":"_2IDLb","right-side-item-wrapper":"_15yNm","rightSideItemWrapper":"_15yNm"};